module.exports = "/assets/data/52df737d783546f4f68bac1eba998695-MK19.data.json";